"use client";

import Link from "next/link";
import useLanguage from "src/context/useLanguage";

export default function NotFound() {
  const { language, translations } = useLanguage();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center p-6 bg-white">
      <h1 className="text-5xl font-ibmArabic text-gray-800 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-6 font-ibmArabic">
        {translations[language].section1.notfound}
      </p>
      <Link
        href="/"
        className="text-white font-ibmArabic bg-[#E5BB32]  font-medium py-2 px-4 rounded-lg"
      >
        {translations[language].section1.Gobackhome}
      </Link>
    </div>
  );
}
